// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"SuccessModal_modal-wrapper__3-kK7"};